import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../../layouts/MainPagetitle';
import MyComplaintsModal from './MyComplaintsModal';
import MyComplaintsSearch from './MyComplaintsSearch';
import HaveAnIssue from './HaveAnIssue';
import MyComplaintsOverview from './MyComplaintsOverview';

const MyComplaints = (props) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [complaints, setComplaints] = useState([]);
  const [complaintsOverview, setComplaintsOverview] = useState([]);
  const complaintsOverviewCards = ['total', 'inProgress', 'awaitingReview', 'resolved', 'reopened', 'closed'];
  const [rowcount, setRowcount] = useState(0);
  const [isFetching, setIsFetching] = useState(true);
  const columns = [
    {
      dataIndex: 'complaintId',
      title: 'Complaint ID',
      render: (text, record) => {
        return (
          <>
            <div>
              <h6 className="text-primary fw-bold">{text || '-'}</h6>
            </div>
          </>
        );
      },
    },
    {
      dataIndex: 'loanAccountNumber',
      title: 'LAN',
    },
    {
      dataIndex: 'categoryOfService',
      title: 'Category of Service',
      render: (text, record) => {
        return _enum.CATEGORY_OF_SERVICE_LIST_REVERSE_MAP[record?.categoryOfService] || '-';
      },
    },
    {
      dataIndex: 'createdAt',
      title: 'Raised On',
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.createdAt) {
          return date;
        } else {
          return '-';
        }
      },
    },
    {
      dataIndex: 'status',
      title: 'Application Status',
      render: (text, record) => {
        let mappedStatus = _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || '';
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const view = (record) => {
    let { complaintId } = record;
    let path = `/app/mycomplaintsview?id=${complaintId}&readonly=true`;
    navigate(path);
  };

  const edit = (record) => {
    let { complaintId } = record;
    let path = `/app/mycomplaintsview?id=${complaintId}`;
    navigate(path);
  };

  const onSearch = (data, reset) => {
    console.log('onSearch on complaints', data, reset);
    let defaultSearchData = Object.only(data, ['limit', 'page']);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
      getComplaints(payload, reset);
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
      getComplaints(payload, reset);
    }
    setSearch(payload);
  };

  const getComplaintsOverview = () => {
    props.apis.apiGetComplaintCards().then((res) => {
      setComplaintsOverview(res);
    });
  };

  const getComplaints = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ['page', 'limit']);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetAllComplaints(payload).then(({ data, total }) => {
      setComplaints(data);
      setRowcount(total);
      setIsFetching(false);
    });
  };
  //   ---------------------------------------------------------
  const [complaintsAttachmentsData, setComplaintsAttachmentsData] = useState([]);
  const [attachmentsFields, setAttachmentsFields] = useState([{ attachments: '' }]);
  const [attachmentsInputData, setAttachmentsInputData] = useState([
    {
      label: 'Attach Supporting Document (PDF / Images)',
      name: 'attachments',
      type: 'file',
    },
  ]);
  const [modalFields, setModalFields] = useState([
    {
      name: 'categoryOfService',
      label: 'Category Of Service',
      type: 'select',
      options: _enum.CATEGORY_OF_SERVICE_LIST,
      placeholder: 'Category Of Service',
      required: true,
      customcolspan: '12',
    },
    {
      name: 'loanAccountNumber',
      label: 'Enter Loan Account Number (LAN)',
      type: 'text',
      placeholder: 'Enter Loan Account Number (LAN)',
      required: true,
      customcolspan: '12',
    },
    {
      name: 'complaintTitle',
      label: 'Subject Title',
      type: 'text',
      placeholder: 'Subject Title',
      customcolspan: '12',
    },
    {
      name: 'complaintExplanation',
      label: 'Complaint Explanation',
      type: 'text',
      placeholder: 'Complaint Explanation',
      customcolspan: '12',
    },
    // {
    //   label: "Attach Supporting Document (PDF / Images)",
    //   name: "attachmentsTitle",
    //   type: "textarea",
    //   customcolspan: 12,
    //   outerclass: "form-title",
    // },
  ]);
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce((o, n) => ({ ...o, [n.name]: n }), {});
    let formdata = Object.map(fields, (v, k) => '');
    console.log('formdata: ', fields, formdata);
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    console.log('onModalClose');
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    console.log('formdata: ', data);
    let parsedData = parseInput(data || {});

    let attachments = [];
    if (Array.isArray(parsedData?.dynamicfield)) {
      attachments = parsedData.dynamicfield
        .map((item) => item?.attachments)
        .filter((att) => att && typeof att === 'string' && att.trim() !== '');
    } else if (Array.isArray(parsedData?.attachments)) {
      attachments = parsedData.attachments.filter(
        (att) => att && typeof att === 'string' && att.trim() !== ''
      );
    } else if (
      typeof parsedData?.attachments === 'string' &&
      parsedData.attachments.trim() !== ''
    ) {
      attachments = [parsedData.attachments];
    }

    let payload = {
      customerName: (
        parsedData?.customerName ||
        props?.$store?.user?.customerName ||
        props?.$store?.user?.name ||
        ''
      ).toString(),
      mobileNumber: (
        parsedData?.mobileNumber ||
        props?.$store?.user?.mobileNumber ||
        props?.$store?.user?.mobile ||
        ''
      ).toString(),
      emailId: (
        parsedData?.emailId ||
        parsedData?.emailAddress ||
        parsedData?.email ||
        props?.$store?.user?.emailId ||
        props?.$store?.user?.emailAddress ||
        props?.$store?.user?.email ||
        ''
      ).toString(),
      loanAccountNumber: (parsedData?.loanAccountNumber || '').toString(),
      isExistingCustomer:
        typeof parsedData?.isExistingCustomer === 'boolean' ? parsedData.isExistingCustomer : true,
      source: (parsedData?.source || 'PORTAL').toString(),
      queryType: (parsedData?.queryType || 'GENERAL').toString(),
      categoryOfService: (parsedData?.categoryOfService || '').toString(),
      complaintTitle: (parsedData?.complaintTitle || '').toString(),
      complaintExplanation: (parsedData?.complaintExplanation || '').toString(),
      attachments: attachments,
    };
    console.log('payload: ', payload);

    props.apis
      .apiCreateComplaint(payload)
      .then((res) => {
        swal2.fire({
          title: 'Complaint added successfully.',
          icon: 'success',
          iconColor: '#FF4D4D',
          timer: 4000,
        });
        closeModal();
        getComplaints();
      })
      .catch((err) => {
        console.error('Error creating complaint:', err);
        swal2.fire({
          title: err?.message || 'Failed to create complaint',
          icon: 'error',
          iconColor: '#DE3232',
          timer: 4000,
        });
      });
  };

  useEffect(() => {
    getComplaints();
    getComplaintsOverview();
  }, [search]);

  return (
    <>
      <MainPagetitle
        mainTitle="My Complaints"
        pageTitle={'My Complaints'}
        parentTitle={'Home'}
        pageIcon={imagepaths.complaintsIconActive}
      />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xl-6 col-lg-6 col-md-12 mb-3 mb-lg-0">
            <HaveAnIssue
              title="Have an issue?"
              description="Raise a complaint with us and we will get back to you."
              onRaiseComplaint={() => addModalFields()}
            />
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <MyComplaintsOverview title="My Complaints Overview" cards={complaintsOverviewCards} data={complaintsOverview} />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container">
                  <h4 className="heading mb-0">Recently Complaints</h4>
                  <div className="d-flex">
                    <MyComplaintsSearch onSearch={(...arg) => onSearch(...arg)} />
                  </div>
                </div>
                <AppTable
                  data={complaints}
                  total={rowcount}
                  onChange={(...arg) => onPageChange(...arg)}
                  columns={columns}
                  reorder={true}
                  viewAction={(...args) => view(...args)}
                  editAction={(...args) => edit(...args)}
                  deletable={false}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MyComplaintsModal
        id="myComplaintsCanvas"
        title={`${editmode ? 'Edit Complaint' : viewmode ? 'View Complaint' : 'Raise Complaint'}`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? 'Update' : 'Submit'}`}
        disableallfields={viewmode ? true : false}
        hasDynamicFields={true}
        dynamicfields={attachmentsFields}
        dynamicfieldid="attachments"
        dynamicdefaultdata={complaintsAttachmentsData}
        dynamicinputs={attachmentsInputData}
        dynamicinputsColClass="col-12 col-md-12 col-lg-8"
      />
    </>
  );
};

export default constore(MyComplaints);
